import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { AppContext } from '@/contexts/AppContext';
import { getHttpResponse } from '@/api/helper';
/** @typedef {import("@/types/Giftcard").GiftcardResponse} GiftcardResponse  */
const useGetGiftcardsQuery = (userId) => {
  const {  token, userId:providerUserId} = useContext(AppContext);
   /** @type {()=>Promise<import("axios").AxiosResponse<GiftcardResponse ,any>>} */
  const fetchFn = () =>{
    return getHttpResponse(`/benefit-service/giftcards?catalogTypeId=2&userId=${userId}`, token, providerUserId)
  }

 
  return useQuery({
    queryKey: ['giftcards', userId],
    staleTime: 300,
    enabled: !!userId,
    refetchOnWindowFocus:false,
    queryFn: fetchFn
  });
};

export default useGetGiftcardsQuery;